import { render, staticRenderFns } from "./GoodsForm.vue?vue&type=template&id=3912fde1"
import script from "./GoodsForm.vue?vue&type=script&lang=js"
export * from "./GoodsForm.vue?vue&type=script&lang=js"
import style0 from "./GoodsForm.vue?vue&type=style&index=0&id=3912fde1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports